<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Btm from "../components/Btm.svelte";

    let cus_name = "";
    let cus_name_check = "";

    let citem_name = "";
    let citem_name_check = "";

    let addr1_check = "";
    let addr2_check = "";
    let addr3_check = "";

    let phone_check = "";

    let addr1 = "";
    let addr2 = "";
    let addr3 = "";
    let phone = "";
    let symptom_cus = "";
    let as_request = "N";

    let isCusModalOpen = false;
    let isItemModalOpen = false;

    let newName = "";
    let newPhone = "";
    let newNameRpr = "";
    let newPhoneRpr = "";
    let newItemName = "";

    // function kakaopost() {
    //     new daum.Postcode({
    //         oncomplete: function (data) {
    //             addr1 = data.address + " ";
    //             addr3 = data.zonecode;
    //             addr2 = "";
    //         },
    //     }).open();
    // }

    function kakaopost() {
        new daum.Postcode({
            oncomplete: function (data) {
                // 1. 데이터 바인딩
                addr1 = data.address + " ";
                addr3 = data.zonecode;
                addr2 = "";

                // 2. 창 강제 닫기 (핵심)
                closeAddrLayer();
            },
            width: "100%",
            height: "100%",
            maxSuggestItems: 5,
        }).embed(document.getElementById("addr_layer")); // open 대신 embed 사용

        // 레이어 보이기 및 스타일 지정
        const layer = document.getElementById("addr_layer");
        layer.style.display = "block";

        // 모바일 전체화면 설정
        layer.style.width = "100%";
        layer.style.height = "100%";
        layer.style.top = "0";
        layer.style.left = "0";
    }

    function closeAddrLayer() {
        document.getElementById("addr_layer").style.display = "none";
    }

    // 고객 팝업 열기
    function cus_pop() {
        getCustomList();
        isCusModalOpen = true;
    }

    // 고객 팝업 닫기
    function cus_pop_close() {
        isCusModalOpen = false;
        searchCusKeyword = "";
        newName = "";
        newPhone = "";
        newNameRpr = "";
        newPhoneRpr = "";
    }

    // 아이템 팝업 열기
    function item_pop() {
        if (customIndex == null) {
            alert("업체를 먼저 선택해주세요.");
            cus_pop();
            return;
        }

        getCitemList();
        isItemModalOpen = true;
    }

    // 아이템 팝업 닫기
    function item_pop_close() {
        isItemModalOpen = false;
        searchCitemKeyword = "";
        newItemName = "";
    }

    let customIndex = null;

    function handleClick(index, name, addr1_, addr2_, addr3_, phone_) {
        cus_name_check = name;
        addr1_check = addr1_;
        addr2_check = addr2_;
        addr3_check = addr3_;
        phone_check = phone_;

        if (customIndex === index) {
            // 이미 선택된 항목이면 해제
            customIndex = null;
        } else {
            customIndex = index;
        }
    }

    // 버튼 배경 색 결정
    $: btnBackground =
        customIndex !== null
            ? "var(--Color-on, #4E8EED)"
            : "var(--Color-line, #E4E8EA)";

    ///////////////////////////////////////////////////////
    let citemIndex = null;

    function handleClick_citem(index, name) {
        citem_name_check = name;

        if (citemIndex === index) {
            // 이미 선택된 항목이면 해제
            citemIndex = null;
        } else {
            citemIndex = index;
        }
    }

    // 버튼 배경 색 결정
    $: btnBackground_citem =
        citemIndex !== null
            ? "var(--Color-on, #4E8EED)"
            : "var(--Color-line, #E4E8EA)";

    let pageSize = 10; // 한 번에 로드할 데이터 개수
    let currentPage = 0; // 현재 페이지
    let currentList = [];
    let dataList = [];

    let searchCusKeyword = "";

    async function getCustomList() {
        const response = await api.get(
            `/custom?&keyword=${encodeURIComponent(searchCusKeyword)}&page=1&sort=${decodeURI("a.name")}&cate=&usePageNavy=false`,
        );

        if (response != null) {
            currentPage = 0;
            currentList = [];
            dataList = response.data;
            loadMore();
        }
    }

    function loadMore() {
        const start = currentPage * pageSize;
        const end = start + pageSize;

        currentList = [...currentList, ...dataList.slice(start, end)];
        currentPage++;
    }

    function handleScroll(event) {
        const { scrollTop, scrollHeight, clientHeight } = event.target;

        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if (currentList.length < dataList.length) {
                loadMore();
            }
        }
    }

    let searchCitemKeyword = "";
    let dataList_citem_all = [];

    async function getCitemList() {
        const response = await api.get(`/citem/as?cus_id=${customIndex}`);

        if (response != null) {
            dataList_citem_all = response.data;
            filterCitem();
        }
    }

    function filterCitem() {
        currentPage_citem = 0;
        currentList_citem = [];
        dataList_citem = dataList_citem_all.filter((item) =>
            item.item_name
                ? item.item_name
                      .toLowerCase()
                      .includes(searchCitemKeyword.toLowerCase())
                : false,
        );
        loadMore_citem();
    }

    let pageSize_citem = 10; // 한 번에 로드할 데이터 개수
    let currentPage_citem = 0; // 현재 페이지
    let currentList_citem = [];
    let dataList_citem = [];

    function loadMore_citem() {
        const start = currentPage_citem * pageSize_citem;
        const end = start + pageSize_citem;

        currentList_citem = [
            ...currentList_citem,
            ...dataList_citem.slice(start, end),
        ];
        currentPage_citem++;
    }

    function handleScroll_citem(event) {
        const { scrollTop, scrollHeight, clientHeight } = event.target;

        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if (currentList_citem.length < dataList_citem.length) {
                loadMore_citem();
            }
        }
    }

    function formatPhoneNumber(num) {
        if (!num) return "";

        const digits = String(num).replace(/\D/g, "");

        if (digits.length === 10) {
            // 10자리: 3-3-4
            if (digits.startsWith("02")) {
                return digits.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
            }
            return digits.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        } else if (digits.length === 11) {
            // 11자리: 3-4-4
            return digits.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        } else {
            // 그 외는 그대로 출력
            return num;
        }
    }

    async function saveClick() {
        if (customIndex == null) {
            alert("업체를 먼저 선택해주세요.");
            return;
        }

        if (citemIndex == null) {
            alert("제품을 먼저 선택해주세요.");
            return;
        }

        if (Common.nullCheck(addr1, "addr1", "주소")) return;
        if (Common.nullCheck(phone, "phone", "연락처")) return;

        symptom_cus = (symptom_cus || "").replaceAll("<br>", "\r\n");

        const formData = {
            cus_id: customIndex,
            citem_id: citemIndex,
            addr1,
            addr2,
            addr3,
            phone,
            symptom_cus,
            as_request,
        };

        const response = await api.post("/as", formData);

        if (response != null) {
            alert(response.msg);
            push("/AsList");
        }
    }

    async function saveCustom() {
        if (Common.nullCheck(newName, "new_name", "접수처명")) return;
        if (Common.nullCheck(newPhone, "new_phone", "접수처 연락처")) return;
        if (Common.nullCheck(newNameRpr, "new_name_rpr", "수리처명")) return;
        if (Common.nullCheck(newPhoneRpr, "new_phone_rpr", "수리처 연락처"))
            return;

        const formData = {
            name: newName,
            phone: newPhone,
            addr1: "",
            addr2: "",
            addr3: "",
            note: "",
            name_rpr: newNameRpr,
            phone_rpr: newPhoneRpr,
            addr1_rpr: "",
            addr2_rpr: "",
            addr3_rpr: "",
            note_rpr: "",
        };

        const response = await api.post("/custom", formData);

        if (response != null) {
            alert("신규 업체가 추가되었습니다.");

            handleClick(
                response.data.cus_id,
                newName + " / " + newNameRpr,
                "",
                "",
                "",
                newPhone,
            );

            cus_name = newName + " / " + newNameRpr;
            phone = newPhone;

            cus_pop_close();
            item_pop();
        }
    }

    async function saveCitem() {
        if (Common.nullCheck(newItemName, "new_item_name", "제품명")) return;

        const formData = {
            cus_id: customIndex,
            item_name: newItemName,
            repair_id: 0,
            repair_cmpn_id: 0,
            ins_at: new Date().toISOString().substring(0, 10),
        };

        const response = await api.post("/citem", formData);

        if (response != null) {
            alert("신규 제품이 추가되었습니다.");

            handleClick_citem(response.data.citem_id, newItemName);

            citem_name = newItemName;
            item_pop_close();
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-missing-attribute -->
<!-- svelte-ignore a11y-label-has-associated-control -->
<div class="main-body custom-form">
    <div class="main-content">
        <header class="form-header">
            <button class="back-btn" on:click={() => window.history.back()}>
                <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                >
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>
            <h1>신규 접수 등록</h1>
        </header>

        <div class="form-scroll-area scroll-custom">
            <!-- 1. 기본 정보 섹션 -->
            <section class="form-section">
                <h2 class="section-title">기본 정보</h2>

                <div class="input-group">
                    <label>
                        접수 타입 <span class="required">*</span>
                    </label>
                    <div class="select-wrapper">
                        <select bind:value={as_request}>
                            <option value="N">신규 접수</option>
                            <option value="Y">재콜 접수</option>
                        </select>
                    </div>
                </div>

                <div class="input-group">
                    <label>
                        접수처/수리처 <span class="required">*</span>
                    </label>
                    <div class="select-input-wrapper" on:click={cus_pop}>
                        <input
                            type="text"
                            placeholder="업체를 선택해주세요"
                            bind:value={cus_name}
                            readonly
                        />
                        <svg
                            class="chevron-icon"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            stroke="currentColor"
                            stroke-width="2"
                            fill="none"
                        >
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </div>
                </div>

                <div class="input-group">
                    <label>
                        제품명 <span class="required">*</span>
                    </label>
                    <div class="select-input-wrapper" on:click={item_pop}>
                        <input
                            type="text"
                            placeholder="제품을 선택해주세요"
                            bind:value={citem_name}
                            readonly
                        />
                        <svg
                            class="chevron-icon"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            stroke="currentColor"
                            stroke-width="2"
                            fill="none"
                        >
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </div>
                </div>
            </section>

            <!-- 2. 방문 정보 섹션 -->
            <section class="form-section">
                <h2 class="section-title">방문 및 연락처</h2>

                <div class="input-group">
                    <label>
                        방문 주소 <span class="required">*</span>
                    </label>
                    <div class="address-grid">
                        <input
                            type="text"
                            placeholder="우편번호"
                            bind:value={addr3}
                            readonly
                            on:click={kakaopost}
                        />
                        <button class="secondary-btn" on:click={kakaopost}>
                            주소 검색
                        </button>
                    </div>
                    <input
                        type="text"
                        class="mt-2"
                        placeholder="기본 주소"
                        bind:value={addr1}
                        readonly
                        on:click={kakaopost}
                    />
                    <input
                        type="text"
                        class="mt-2"
                        placeholder="상세 주소를 입력해주세요"
                        bind:value={addr2}
                    />
                </div>

                <div class="input-group">
                    <label>
                        연락처 <span class="required">*</span>
                    </label>
                    <input
                        type="text"
                        maxlength="11"
                        placeholder="'-' 없이 숫자만 입력"
                        inputmode="numeric"
                        bind:value={phone}
                    />
                </div>
            </section>

            <!-- 3. 증상 섹션 -->
            <section class="form-section">
                <h2 class="section-title">상세 증상</h2>
                <div class="input-group">
                    <label>고객 증상</label>
                    <textarea
                        placeholder="증상을 자세히 입력해주세요"
                        bind:value={symptom_cus}
                        rows="5"
                    ></textarea>
                </div>
            </section>

            <div class="form-actions">
                <button class="submit-btn" on:click={saveClick}>
                    접수 등록하기
                </button>
            </div>
        </div>

        <Btm />
    </div>

    <!-- 주소 레이어 -->
    <div
        id="addr_layer"
        style="display:none;position:fixed;z-index:2000000;border:1px solid;width:100%;height:100%;top:0;left:0;"
    >
        <button
            on:click={closeAddrLayer}
            style="position:absolute;right:0;top:-30px;z-index:1"
        >
            닫기
        </button>
    </div>

    <!-- 고객/업체명 팝업 -->
    <div class="modal-overlay" class:show={isCusModalOpen} id="cus_modal">
        <div class="modal-window">
            <header class="modal-header">
                <h2>접수처/수리처 선택</h2>
                <button class="close-btn" on:click={cus_pop_close}>
                    <svg
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                    >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </header>

            <div class="modal-search">
                <input
                    type="text"
                    bind:value={searchCusKeyword}
                    placeholder="검색어 입력"
                    on:keypress={(e) => e.key === "Enter" && getCustomList()}
                />
                <button class="secondary-btn" on:click={getCustomList}>
                    검색
                </button>
            </div>

            <div class="modal-content scroll-custom" on:scroll={handleScroll}>
                {#if as_request === "N"}
                    <div class="add-new-section">
                        <h3>신규 업체 등록</h3>
                        <div class="form-grid">
                            <input
                                type="text"
                                bind:value={newName}
                                placeholder="*접수처명"
                            />
                            <input
                                type="tel"
                                bind:value={newPhone}
                                placeholder="*접수처 연락처"
                            />
                            <input
                                type="text"
                                bind:value={newNameRpr}
                                placeholder="*수리처명"
                            />
                            <input
                                type="tel"
                                bind:value={newPhoneRpr}
                                placeholder="*수리처 연락처"
                            />
                        </div>
                        <button class="add-btn" on:click={saveCustom}>
                            신규 업체 등록하기
                        </button>
                    </div>
                {/if}

                <div class="modal-list">
                    <h3 class="list-divider-title">업체 리스트</h3>
                    {#if currentList && currentList.length > 0}
                        {#each currentList as data, index}
                            <div
                                class="modal-item {customIndex === data.cus_id
                                    ? 'selected'
                                    : ''}"
                                on:click={() =>
                                    handleClick(
                                        data.cus_id,
                                        data.name,
                                        data.addr1,
                                        data.addr2,
                                        data.addr3,
                                        data.phone,
                                    )}
                            >
                                <div class="item-info">
                                    <p class="item-name">
                                        {data.name} / {data.name_rpr}
                                    </p>
                                    <p class="item-sub">
                                        접수처: {formatPhoneNumber(data.phone)}
                                    </p>
                                    <p class="item-sub">
                                        수리처: {formatPhoneNumber(
                                            data.phone_rpr,
                                        )}
                                    </p>
                                    <p class="item-sub">
                                        주소: {data.addr1}
                                        {data.addr2}
                                    </p>
                                </div>
                            </div>
                        {/each}
                    {:else}
                        <div class="empty-state">검색된 업체가 없습니다.</div>
                    {/if}
                </div>
            </div>

            <footer class="modal-footer">
                <button
                    class="submit-btn"
                    style="background: {btnBackground}"
                    on:click={() => {
                        if (customIndex != null) {
                            if (cus_name != cus_name_check) {
                                citem_name = "";
                            }
                            cus_name = cus_name_check;
                            addr1 = addr1_check;
                            addr2 = addr2_check;
                            addr3 = addr3_check;
                            phone = phone_check;
                            cus_pop_close();
                            item_pop();
                        }
                    }}
                >
                    선택 완료
                </button>
                {#if as_request === "Y"}
                    <p class="footer-hint">
                        원하는 업체가 없나요? '신규 접수'로 타입을 변경해
                        주세요.
                    </p>
                {/if}
            </footer>
        </div>
    </div>

    <!-- 설치제품 팝업 -->
    <div class="modal-overlay" class:show={isItemModalOpen} id="item_modal">
        <div class="modal-window">
            <header class="modal-header">
                <h2>설치제품 선택</h2>
                <button class="close-btn" on:click={item_pop_close}>
                    <svg
                        viewBox="0 0 24 24"
                        width="24"
                        height="24"
                        stroke="currentColor"
                        stroke-width="2"
                        fill="none"
                    >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </header>

            <div class="modal-search">
                <input
                    type="text"
                    bind:value={searchCitemKeyword}
                    placeholder="제품명 검색"
                    on:keypress={(e) => e.key === "Enter" && filterCitem()}
                />
                <button class="secondary-btn" on:click={filterCitem}>
                    검색
                </button>
            </div>

            <div
                class="modal-content scroll-custom"
                on:scroll={handleScroll_citem}
            >
                <div class="modal-list">
                    <div class="add-new-section">
                        <h3>신규 제품 등록</h3>
                        <input
                            type="text"
                            bind:value={newItemName}
                            placeholder="*제품명"
                        />
                        <button class="add-btn" on:click={saveCitem}>
                            신규 제품 등록하기
                        </button>
                    </div>

                    <h3 class="list-divider-title">제품 리스트</h3>

                    {#if currentList_citem && currentList_citem.length > 0}
                        {#each currentList_citem as data, index}
                            <div
                                class="modal-item {citemIndex === data.citem_id
                                    ? 'selected'
                                    : ''}"
                                on:click={() =>
                                    handleClick_citem(
                                        data.citem_id,
                                        data.item_name,
                                    )}
                            >
                                <div class="item-info">
                                    <p class="item-name">{data.item_name}</p>
                                    <p class="item-sub">
                                        설치일: {data.ins_at.split(" ")[0]}
                                    </p>
                                </div>
                            </div>
                        {/each}
                    {:else}
                        <div class="empty-state">검색된 제품이 없습니다.</div>
                    {/if}
                </div>
            </div>

            <footer class="modal-footer">
                <button
                    class="submit-btn"
                    style="background: {btnBackground_citem}"
                    on:click={() => {
                        if (citemIndex != null) {
                            citem_name = citem_name_check;
                            item_pop_close();
                        }
                    }}
                >
                    선택 완료
                </button>
            </footer>
        </div>
    </div>
</div>

<style>
    .custom-form.main-body {
        background-color: var(--bg-primary) !important;
        min-height: 100vh;
    }
    .custom-form .main-content {
        max-width: 1024px;
        margin: 0 auto;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background-color: var(--bg-primary);
    }

    /* Header */
    .custom-form .form-header {
        background-color: var(--bg-secondary);
        padding: 18px 16px;
        display: flex;
        align-items: center;
        gap: 16px;
        border-bottom: 1px solid var(--border-color);
        position: sticky;
        top: 0;
        z-index: 100;
    }
    .custom-form .back-btn {
        background: none;
        border: none;
        color: var(--text-primary);
        cursor: pointer;
        padding: 4px;
    }
    .custom-form h1 {
        font-size: 20px;
        font-weight: 800;
        color: var(--text-primary);
        margin: 0;
        letter-spacing: -0.5px;
    }

    /* Scroll Area */
    .custom-form .form-scroll-area {
        flex: 1;
        overflow-y: auto;
        padding: 16px;
        padding-bottom: 100px;
    }

    /* Form Section */
    .custom-form .form-section {
        background-color: var(--bg-secondary);
        border-radius: var(--radius-md);
        padding: 20px;
        margin-bottom: 16px;
        box-shadow: var(--shadow-sm);
        border: 1px solid var(--border-color);
    }
    .custom-form .section-title {
        font-size: 17px;
        font-weight: 800;
        color: var(--color-primary);
        margin-bottom: 24px;
        padding-left: 12px;
        border-left: 5px solid var(--color-primary);
    }

    /* Input Groups */
    .custom-form .input-group {
        margin-bottom: 20px;
    }
    .custom-form .input-group:last-child {
        margin-bottom: 0;
    }
    .custom-form label {
        display: block;
        font-size: 15px;
        font-weight: 700;
        color: var(--text-secondary);
        margin-bottom: 10px;
    }
    .custom-form .required {
        color: var(--color-error);
    }

    /* Inputs & Selects */
    .custom-form input,
    .custom-form select,
    .custom-form textarea {
        width: 100%;
        padding: 14px 16px;
        min-height: 54px;
        background-color: var(--bg-primary);
        border: 1px solid var(--border-color);
        border-radius: 10px;
        color: var(--text-primary);
        font-size: 16px;
        transition: all 0.2s;
        line-height: 1.4;
    }
    .custom-form input:focus,
    .custom-form select:focus,
    .custom-form textarea:focus {
        border-color: var(--color-primary);
        outline: none;
    }

    /* Select Input Wrapper */
    .custom-form .select-input-wrapper {
        position: relative;
        cursor: pointer;
    }
    .custom-form .chevron-icon {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: var(--text-tertiary);
        pointer-events: none;
    }

    /* Address Grid */
    .custom-form .address-grid {
        display: grid;
        grid-template-columns: 1fr 100px;
        gap: 8px;
        margin-bottom: 8px;
    }

    /* Buttons */
    .custom-form .secondary-btn {
        background-color: var(--bg-tertiary);
        border: 1px solid var(--border-color);
        color: var(--text-primary);
        padding: 8px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
    }

    .custom-form .form-actions {
        margin-top: 8px;
    }
    .custom-form .submit-btn {
        width: 100%;
        padding: 16px;
        background-color: var(--color-primary);
        color: white;
        border: none;
        border-radius: 12px;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
        transition: transform 0.2s;
    }
    .custom-form .submit-btn:active {
        transform: scale(0.98);
    }

    .custom-form .mt-2 {
        margin-top: 8px;
    }

    /* Modern Modal Styles */
    .custom-form .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: none;
        justify-content: center;
        align-items: flex-end;
        z-index: 1000000;
    }
    .custom-form .modal-overlay.show {
        display: flex !important;
    }

    .custom-form .modal-window {
        width: 100%;
        max-width: 600px;
        background: var(--bg-secondary);
        border-radius: 24px 24px 0 0;
        display: flex;
        flex-direction: column;
        max-height: 90vh;
        animation: slideUp 0.3s ease-out;
    }
    @keyframes slideUp {
        from {
            transform: translateY(100%);
        }
        to {
            transform: translateY(0);
        }
    }

    .custom-form .modal-header {
        padding: 20px;
        border-bottom: 1px solid var(--border-color);
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .custom-form .modal-header h2 {
        font-size: 20px;
        font-weight: 800;
        margin: 0;
    }
    .custom-form .close-btn {
        background: none;
        border: none;
        color: var(--text-tertiary);
        cursor: pointer;
    }

    .custom-form .footer-hint {
        font-size: 12px;
        color: var(--text-tertiary);
        text-align: center;
        margin-top: 12px;
    }

    .custom-form .modal-search {
        padding: 20px 20px 0 20px;
        display: flex;
        gap: 8px;
    }
    .custom-form .modal-search input {
        flex: 1;
        min-height: 44px;
        padding: 10px 14px;
    }
    .custom-form .modal-search .secondary-btn {
        min-height: 44px;
        padding: 0 16px;
    }

    .custom-form .modal-content {
        flex: 1;
        overflow-y: auto;
        padding: 20px;
    }
    .custom-form .modal-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .custom-form .add-new-section {
        background: var(--bg-primary);
        border: 1px dashed var(--color-primary);
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 20px;
    }
    .custom-form .add-new-section h3 {
        font-size: 14px;
        color: var(--color-primary);
        margin: 0 0 12px 0;
    }
    .custom-form .form-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px;
        margin-bottom: 12px;
    }
    .custom-form .add-new-section input {
        padding: 10px;
        font-size: 13px;
        margin-bottom: 8px;
    }
    .custom-form .add-new-section .form-grid input {
        margin-bottom: 0;
    }
    .custom-form .add-btn {
        width: 100%;
        padding: 12px;
        background: var(--color-primary);
        color: white;
        border: none;
        border-radius: 8px;
        font-weight: 600;
        cursor: pointer;
        margin-top: 4px;
    }
    .custom-form .list-divider-title {
        font-size: 14px;
        font-weight: 700;
        color: var(--text-tertiary);
        margin: 10px 0 15px 4px;
    }

    .custom-form .modal-item {
        padding: 18px;
        border-radius: 12px;
        background: var(--bg-primary);
        min-height: 80px;
        display: flex;
        align-items: center;
        border: 2px solid transparent;
        cursor: pointer;
        transition: all 0.2s;
    }
    .custom-form .modal-item.selected {
        border-color: var(--color-primary);
        background: var(--bg-secondary);
    }
    .custom-form .item-name {
        font-weight: 700;
        font-size: 17px;
        margin-bottom: 6px;
    }
    .custom-form .item-sub {
        font-size: 14px;
        color: var(--text-secondary);
        margin: 2px 0;
    }

    .custom-form .empty-state {
        text-align: center;
        padding: 40px 20px;
        color: var(--text-tertiary);
        font-size: 15px;
        background: var(--bg-primary);
        border-radius: 12px;
    }

    .custom-form .modal-footer {
        padding: 16px;
        border-top: 1px solid var(--border-color);
    }
    .custom-form .submit-btn {
        width: 100%;
        padding: 16px;
        color: white;
        border: none;
        border-radius: 12px;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
    }
</style>
